import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy, ViewChild, AfterViewInit, Input, ViewChildren, QueryList, ContentChildren,
} from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { NzMessageService, NzDrawerRef, NzModalService } from 'ng-zorro-antd';
import {ActivatedRoute} from "@angular/router";
import { LcGridFormComponent } from '../lc-grid-form/lc-grid-form.component';
import { DynamicComponentDetailFormService } from './service/dynamic-component-detail-from.service';
import { DynamicComponentDetailFormGetMetaInfoRequest } from './service/model/dynamicComponentDetailFormGetMetaInfoRequest';
import { DynamicComponentDetailFormGetMetaInfoForm } from './service/model/dynamicComponentDetailFormGetMetaInfoForm';
import { DynamicComponentDetailFormGetMetaInfoTool } from './service/model/dynamicComponentDetailFormGetMetaInfoTool';
import { DynamicComponentDetailFormGetMetaInfoCol } from './service/model/dynamicComponentDetailFormGetMetaInfoCol';
import { DynamicComponentDetailFormGetModelRequest } from './service/model/dynamicComponentDetailFormGetModelRequest';
@Component({
  selector: 'lc-detail-form',
  templateUrl: './lc-detail-form.component.html',
  styleUrls: ['./lc-detail-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DynamicComponentDetailFormService]
})
export class LcDetailFormComponent implements OnInit,AfterViewInit {

  //  @ContentChildren(LcGridFormComponent)
  //  gridForms: QueryList<LcGridFormComponent>;

  id:string;
  _windowFormId: string;
  @Input()
  set windowFormId(value: string) {
      this._windowFormId = value;
      if (this._windowFormId) {
          this.loadData();
      }
  }

  get windowFormId() {
      return this._windowFormId;
  }
  model:any={};
    /**
     * 窗体信息
     */
    form: DynamicComponentDetailFormGetMetaInfoForm = {};
    /**
     * 工具栏信息
     */
    tools: DynamicComponentDetailFormGetMetaInfoTool[] = [];
    /**
     * 窗体列信息
     */
    cols?: DynamicComponentDetailFormGetMetaInfoCol[]=[];
    /**
     * 子窗体信息
     */
    tabForms: DynamicComponentDetailFormGetMetaInfoForm[] = [];

  constructor(
    private msg: NzMessageService,
    private route: ActivatedRoute,
    private service: DynamicComponentDetailFormService
  ) {}
 
  async ngOnInit() {
    const request: DynamicComponentDetailFormGetMetaInfoRequest = {};
    request.id = this.windowFormId;
    const res = await this.service.getMetaInfo(request,{isCache: true});
    this.form= res.data.form;
    this.cols=[...res.data.cols];
    this.tabForms=[...res.data.tabs];
    this.tools=[...res.data.tools];
    this.loadData();
 }
  ngAfterViewInit(): void {
  }

  loadData(): void {
    console.log(this.id);
   if (this.id !== undefined) {
       const request: DynamicComponentDetailFormGetModelRequest = {};
       request.windowFormId = this.windowFormId;
       request.id = this.id;
       this.service.getModel(request).then(res=>{
           this.model = res.data;
       });
   }
}

  doColFormat(item: any, col: DynamicComponentDetailFormGetMetaInfoCol, index: number){
    if(col.formatScript){
        return new Function('item','col','index',col.formatScript)(item,col,index);
    }
    return item[col.colName];

}
visible = false;

open(windowFormId:string,id:string): void {
  this.windowFormId=windowFormId;
  this.id=id;
  this.visible = true;
}

close(): void {
  this.visible = false;
}
}
